/* import services */
import tripsApi from '../api/tripsApi';
import sectionsApi from '../api/sectionsApi';
import ticketsApi from '../api/ticketsApi';
import articlesApi from '../api/articlesApi';
import { showArticleformByStatusAndServiceType } from '../utils/utils';

export const getAllTrips = async () => {
    try {
      const response = await tripsApi.getTripsWithin30Days({ perPage: 10, page: 1 });
      if (response.status) {
        return response.data;
      } else {
        console.error(response.error.msg);
      }
    } catch (error) {
      if (error.response.status !== 404) {
        console.error("Error while fetching trips: " + error.message)
      }
    }
}

export const getTrip = async (tripId, setTrip, setLoadError, setLoading, articleData, setArticleData) => {
    try {
        setLoading(true)
        const response = await tripsApi.getTripById(tripId);
      if (response.status) {
        const tripData = response.data.data
        
        // TO SET THE ARTICLE FORM DATA BASED ON THE TRIP TYPE AND STATUS
        if (articleData?.id && articleData?.formData && articleData?.labels?.length !== 0) {
          if (!showArticleformByStatusAndServiceType(articleData?.labels, tripData.status, tripData.serviceType)) {
            setArticleData((prevState) => {
              return {
                ...prevState,
                formData: null
              }
            })
          }
        }
        setTrip(tripData);
      } else {
        console.error(response.error.msg);
      }
    } catch (error) {
        setLoadError(true);
        console.error("Error while fetching trip: " + error.message)
    } 
  }

export const getAllIssues = async () => {
    try {
      const response = await ticketsApi.getTickets({perPage: 10, page: 1});
      if (response.status) {
        return response.data;
      } else {
        console.error(response.error.msg);
      }
    } catch (error) {
      if (error.response.status !== 404) {
        console.error("Error while fetching tickets: " + error.message)
      }
    }
}

export const getSections = async () => {
    try {
      const response = await sectionsApi.getSections({perPage: 20, page: 1});
      if (response.status) {
        return response.data;
      } else {
        console.error(response.error.msg);
      }
    } catch (error) {
      console.error("Error while fetching sections: " + error.message)
    }
}

export const getSectionsForDashboard = async () => {
  try {
    const response = await sectionsApi.getSectionsForDashboard();
    if (response.status) {
      return response.data;
    } else {
      console.error(response.error.msg);
    }
  } catch (error) {
    console.error("Error while fetching sections: " + error.message)
  }
}

export const getArticle = async (articleId, setArticleData, setLoadError, setLoading, tripId) => { 
    try {
        const response = await articlesApi.getArticle(articleId, tripId);
        if (response.status) {
          setArticleData(response.data.data)
        } else {
          console.error(response.error.msg);
        }
    } catch (error) {
        setLoadError(true);
        console.error("Error while fetching trips: " + error.message)
    } finally {
        setLoading(false);
    }
}